export const DEFAULT_MENU_TYPE = 'menu-hidden' // 'menu-default', 'menu-sub-hidden', 'menu-hidden';

export const BASE_ROUTE_URL = process.env.BASE_URL ?? '/'

export const ADMIN_ROOT = '/admin'
export const SUPER_ADMIN_ROOT = '/superadmin'
export const API_URL = process.env.VUE_APP_API_SERVER ?? 'https://oktabletmenu.com/api'
export const SERVER_URL = process.env.VUE_APP_SERVER ?? 'https://oktabletmenu.com/'

export const SERVER_TIMEZONE = process.env.VUE_APP_SERVER_TIMEZONE || 'Asia/Kuwait'
export const SERVER_OFFSET = process.env.VUE_APP_SERVER_OFFSET || '+03:00'

export const GIS_URL = process.env.VUE_APP_GIS_API_SERVER || 'https://osm.oktabletmenu.com'

export const TAP_TOKEN = process.env.VUE_APP_TAP_KEY ?? 'pk_test_EtHFV4BuPQokJT6jiROls87Y'
export const iPad_url = process.env.VUE_APP_IPAD_URL ?? 'https://apps.apple.com/us/app/ok-menu/id1457807736'
export const android_url = process.env.VUE_APP_ANDROID_URL ?? 'https://play.google.com/store/apps/details?id=com.ok.okmenuplus&hl=en&gl=US'
export const MENU_SCRIPT_URL = process.env.VUE_APP_MENU_SCRIPT_URL ?? 'https://api.oktabletmenu.com/storage/menu.min.js'
export const socketURL = process.env.VUE_APP_ORDER_SOCKET_URL ?? 'wss://oktabletmenu.com/websocket'
export const webAppUrl = process.env.VUE_APP_WEB_APP_URL ?? 'https://okmenuqr.com'

export const STORE_URL = process.env.VUE_APP_IPAD_URL ?? 'https://apps.apple.com/us/app/ok-menu/id1457807736'
export const PLAY_STORE_URL = process.env.VUE_APP_ANDROID_URL ?? 'https://play.google.com/store/apps/details?id=com.ok.okmenuplus&hl=en&gl=US'

export const WEBAPP_URL = process.env.VUE_APP_WEB_APP_URL ?? 'https://estore.wiyakshop.com'

export const CONTACT_EMAIL = process.env.VUE_APP_CONTACT_EMAIL ?? 'hello@oktabletmenu.com'
export const CONTACT_PHONE = process.env.VUE_APP_CONTACT_PHONE ?? '+965 65524430'

export const DOMAIN_SEARCH_API = process.env.VUE_APP_DOMAIN_SEARCH_API ?? 'https://dns.oktabletmenu.com'

export const KITCHEN_URL = process.env.VUE_APP_KITCHEN_URL ?? 'https://kitchen.oktabletmenu.com'

export const POS_URL = process.env.VUE_APP_POS_URL ?? 'https://okpos.netlify.app'

export const NOTIFICATIONS_SOCKETS_HOST = process.env.VUE_APP_NOTIFICATIONS_SOCKETS_HOST ?? 'https://echo-dev.oktabletmenu.com'
export const NOTIFICATIONS_CHANNEL_PREFIX = process.env.VUE_APP_NOTIFICATIONS_CHANNEL ?? 'notifications'

export const OneSignalAppId = process.env.VUE_APP_ONESIGNAL_APP_ID ?? 'dd05b027-0487-4b9d-baa9-7ddc1d7cb5f1'
export const OneSignalSafariId = process.env.VUE_APP_ONESIGNAL_SAFARI_ID ?? 'web.onesignal.auto.40f3c042-9d52-4eaf-84f1-85ef29137faa'

export const GTM_ID = process.env.VUE_APP_GTM_ID ?? 'GTM-TF8XX3M' // Live => 'GTM-TKTH4GG'

export const LOCATION_IQ_TOKEN = process.env.VUE_APP_LOCATION_IQ_TOKEN || 'pk.09a1c6743dc9f6079861e0dd40f0ac8d'

export const HOTJAR_SITE_ID = process.env.VUE_APP_HOTJAR_SITE_ID || '2989784'

export const FOODICS_CLIENT_ID = process.env.VUE_APP_FOODICS_CLIENT_ID || ''
export const FOODICS_API_URL = process.env.VUE_APP_FOODICS_API_URL + FOODICS_CLIENT_ID
export const WISHOP_FOODICS = process.env.VUE_APP_WISHOP_FOODICS || ''
export const WHATSAPP_SERVER = 'https://wa.oktabletmenu.com/api' // `${process.env.VUE_APP_WHATSAPP_SERVER}/api`
export const WHATSAPP_SOCKET = 'https://wa.oktabletmenu.com/' // process.env.VUE_APP_WHATSAPP_SERVER

export const BACKGROUND_REMOVER_SERVER_URL = process.env.VUE_APP_BACKGROUND_REMOVER_SERVER ?? 'https://bg-remover.oktabletmenu.com'
